<div>
    <input type="file" class="hidden-file-input" accept="image/png, image/jpeg" onclick="this.value = null"
      (change)="onFileSelected($event)" #fileUpload required>
    <h1>Add Blog Post</h1>
    <br>
    <form [formGroup]="blogPostForm">
      <label class="fixed-size" for="title">Title: </label>
      <input id="first-name" type="text" formControlName="title">
      <br>
      <label class="fixed-size" for="author">Author: </label>
      <input id="author" type="text" formControlName="author">
      <br>
      <div *ngIf="selectedFile != undefined; else noFile">
        <label class="fixed-size" for="blog-image">Blog Image: </label>
        <label>{{fileName}}</label><button class="remove-button" (click)="removeFile()">x</button>
      </div>
      <ng-template #noFile>
        <label class="fixed-size" for="blog-image">Blog Image: </label>
        <button class="add-button" (click)="fileUpload.click()">Add Image</button>
      </ng-template>
      <br>
      <label for="content">Post Content: </label><br>
      <textarea class="text-area-90" style="background-color:rgb(255, 255, 255);color:rgb(0, 0, 0);" rows="10" cols="40"
        formControlName="content"></textarea>
      <br>
    </form>
    <form [formGroup]="blogPostForm" (ngSubmit)="onSubmit()"></form>
    <p>Note: To add a link to your blog post follow this format:<br> &lt;a href="link"&gt;Text to Click&lt;/a&gt;</p>
    <button class="cancel-button" type="cancel" (click)="this.cancelClicked()">Cancel</button>
    <button class="primary-button" type="submit" [disabled]="!blogPostForm.valid" (click)="this.onSubmit()">Submit</button>
  </div>